"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./Star.style"));

function Star(_ref) {
  var isFill = _ref.isFill,
      isHover = _ref.isHover,
      index = _ref.index;
  return jsx_runtime_1.jsx("svg", Object.assign({
    css: styles.wrapper,
    className: "mrt-star",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    "data-index": index
  }, {
    children: jsx_runtime_1.jsxs("g", Object.assign({
      fill: "none",
      fillRule: "evenodd"
    }, {
      children: [jsx_runtime_1.jsx("path", {
        d: "M0 0H32V32H0z",
        "data-index": index
      }, void 0), jsx_runtime_1.jsx("path", {
        css: styles.fillColor(isHover, isFill),
        // fill={fillColor(isHover, isFill)}
        d: "M16 24.323L6.111 29.333 8 18.72 0 11.204 11.056 9.656 16 0 20.944 9.656 32 11.204 24 18.72 25.889 29.333z",
        "data-index": index
      }, void 0)]
    }), void 0)
  }), void 0);
}

exports.default = Star;